export default {
      MyAccounts: 'Notification|Notifications',
      MyAccounts_no_body: 'Notification',
};
